// Tarp: drop it, blow/rake leaves onto it (they lock when they come to rest
// on it), bag it at ≥ 80 % full. Tarp x/y is the CENTRE, like props.

import type { Ctx } from '../ctx';

export const TARP_BAG_FRACTION = 0.8;

/** Size (m) and capacity (leaves) for a layout: 2×2 m / 60, or 3×3 m / 120 on ovals. */
export function tarpSpec(big: boolean): { size: number; capacity: number } {
  return big ? { size: 3, capacity: 120 } : { size: 2, capacity: 60 };
}

/** Place the tarp at the operator. Moving a tarp with leaves on it isn't allowed — bag it first. */
export function placeTarp(ctx: Ctx): boolean {
  if (!ctx.loadout.includes('tarp')) return false;
  const t = ctx.tarp;
  if (t.placed && t.held > 0) return false;
  t.placed = true;
  t.x = ctx.op.x;
  t.y = ctx.op.y;
  return true;
}

export function canBag(ctx: Ctx): boolean {
  const t = ctx.tarp;
  return t.placed && t.held > 0 && t.held >= TARP_BAG_FRACTION * t.capacity - 1e-9;
}

/** Bag everything locked on the tarp. The tarp stays placed, empty. */
export function bagTarp(ctx: Ctx): boolean {
  if (!canBag(ctx)) return false;
  const L = ctx.leaves;
  let n = 0;
  for (let k = 0; k < L.count; k++) {
    if (L.state[k] === 1) {
      L.state[k] = 2;
      n++;
    }
  }
  ctx.tarp.bagged += n;
  ctx.tarp.held = 0;
  ctx.events.push({ type: 'bagged', count: n });
  return true;
}

/** Lock resting leaf k if it lies on the tarp and there's room. */
export function lockOnTarp(ctx: Ctx, k: number): void {
  const t = ctx.tarp;
  if (!t.placed || t.held >= t.capacity) return;
  const L = ctx.leaves;
  if (Math.abs(L.x[k] - t.x) <= t.w / 2 && Math.abs(L.y[k] - t.y) <= t.h / 2) {
    L.state[k] = 1;
    L.vx[k] = 0;
    L.vy[k] = 0;
    t.held++;
  }
}
